import {
    getCodeUrl,
    userLoginUrl,
    adminUserUrl,
    ssoLoginUrl,
    validMobileUrl,
    validOpenIdUrl,
    testMockLoginUrl,
} from 'Utils/urlUtil';
import {get, post} from 'Utils/apiUtil';
import {removeProfile, loadIdToken, loadProfile} from 'Utils/jwtUtil';
import {setUserData, getLocalData, setAdminData} from 'Actions/localData';

export const GET_CODE = 'GET_CODE';
export const OPENID_VALID = 'OPENID_VALID';
export const GET_OPENID = 'GET_OPENID';
export const LOG_OUT = 'LOG_OUT';
export const ADMIN_USER_LOGIN = 'ADMIN_USER_LOGIN';
export const MOBILE_VALID = 'MOBILE_VALID';
export const CHECK_LOGIN = 'CHECK_LOGIN';
export const GIGYA_LOGIN = 'GIGYA_LOGIN';
export const LOGIN_CODE = 'LOGIN_CODE';

// Link to weChat request code redirect_uri
export function getCode(func) {
    let profile = loadProfile();
    let openId = profile ? profile.openId : '';
    // openId = 'oWHJsw04X_1LJp4JLeOdqlmzOWwQ';

    if (!openId) {
        window.location.href = getCodeUrl;

        return (dispatch) => {
            dispatch({
                type: GET_CODE,
                payload: {},
            });
        };
    } else {
        // Verify that openID is login
        return (dispatch) =>
            dispatch(get(validOpenIdUrl, {openId})).then((response) => {
                dispatch({type: OPENID_VALID, payload: response});

                dispatch(setUserData(response));

                func && func(response);
            });
    }
}

// Send the code request to backend request weChat user's openId.
export function getOpenId(params, func) {
    return (dispatch) =>
        dispatch(get(userLoginUrl, {code: params.code})).then((response) => {
            dispatch({type: GET_OPENID, payload: response});

            dispatch(setUserData(response));

            func && func(response);
        });
}

export function logout() {
    removeProfile();
    return (dispatch) => {
        dispatch({type: LOG_OUT});
    };
}

export function adminLogin(params, func) {
    const data = {
        mobile: params.userName,
        password: params.password,
    };

    return async (dispatch) => {
        return dispatch(post(adminUserUrl, data))
            .then((res) => {
                dispatch({type: ADMIN_USER_LOGIN, payload: res});

                dispatch(setAdminData(res));

                func && func(res);
            })
            .catch((err) =>
                dispatch({type: ADMIN_USER_LOGIN, payload: err || {}}),
            );
    };
}

export function ssoLogin(params, func) {
    return async (dispatch) => {
        return dispatch(get(ssoLoginUrl))
            .then((res) => {
                dispatch({type: ADMIN_USER_LOGIN, payload: res});

                dispatch(setAdminData(res));

                func &&
                    func(
                        res,
                        params.hasTargetURL,
                        params.hasTargetSelectCustomerURL,
                        params.hasTargetUserCenterURL,
                    );
            })
            .catch((err) =>
                dispatch({type: ADMIN_USER_LOGIN, payload: err || {}}),
            );
    };
}

export function validMobile(params) {
    return (dispatch) =>
        dispatch(get(validMobileUrl, {mobile: params}))
            .then((res) => dispatch({type: MOBILE_VALID, payload: res}))
            .catch((err) => dispatch({type: MOBILE_VALID, payload: err}));
}

export function checkLogin() {
    const token = loadIdToken();

    const success = (response) => ({type: CHECK_LOGIN, payload: response});

    return (dispatch) => {
        dispatch(success({data: token}));

        dispatch(getLocalData());
    };
}

// According To Email To Get User Details
export function mockLogin(params, func) {
    let id = params.id;
    let temporaryShipToNumber = params.temporaryShipToNumber;

    return (dispatch) =>
        dispatch(get(testMockLoginUrl, {email: id})).then((response) => {
            if (typeof id !== 'undefined') {
                response.data['temporaryShipToNumber'] = temporaryShipToNumber;
                response.data['scId'] = params.scData.scId;
                response.data['scName'] = params.scData.scName;
                response.data['scType'] = params.scData.scType;
            }
            dispatch(setUserData(response));

            func && func(response);
        });
}
